import "@src/style/scss/CustomButton.scss";

/**
 * Standard text button. Prefer this over bare <button> for labeled actions.
 * @param {"contained"|"outlined"} variant - filled vs outline
 * @param {"primary"|"secondary"|"error"} color - commit / dismiss / destructive
 */
const CustomButton = ({
  variant = "contained",
  color = "primary",
  onClick,
  children,
  type = "button",
  className = "",
  ...rest
}) => {
  const classes = ["customButton", variant, color, className].filter(Boolean).join(" ");
  return (
    <button type={type} className={classes} onClick={onClick} {...rest}>
      {children}
    </button>
  );
};

export default CustomButton;
